import {
    LOAD_MESSAGES_REQUEST,
    LOAD_MESSAGES_SUCCESS,
    LOAD_MESSAGES_FAILED,
    LOAD_MESSAGE_BY_ID_REQUEST,
    LOAD_MESSAGE_BY_ID_SUCCESS,
    LOAD_MESSAGE_BY_ID_FAILED,
    SAVE_MESSAGE_REQUEST,
    SAVE_MESSAGE_SUCCESS,
    SAVE_MESSAGE_FAILED,
    DELETE_MESSAGE_REQUEST,
    DELETE_MESSAGE_SUCCESS,
    DELETE_MESSAGE_FAILED,
    TOGGLE_MESSAGE_REQUEST,
    TOGGLE_MESSAGE_SUCCESS,
    TOGGLE_MESSAGE_FAILED,
    LOAD_ACTIVE_MESSAGES_REQUEST,
    LOAD_ACTIVE_MESSAGES_SUCCESS,
    LOAD_ACTIVE_MESSAGES_FAILED
} from '../actions/ApplicationMessagesAction';

const initialState = {
    listdata: [],
    data: null,
    activeMessages: {},
    pagination: {
        total: 0,
        totalPages: 0,
        currentPage: 1
    },
    loading: false,
    error: null
};

const ApplicationMessagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_MESSAGES_REQUEST:
        case LOAD_MESSAGE_BY_ID_REQUEST:
        case SAVE_MESSAGE_REQUEST:
        case DELETE_MESSAGE_REQUEST:
        case TOGGLE_MESSAGE_REQUEST:
        case LOAD_ACTIVE_MESSAGES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case LOAD_MESSAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.data,
                pagination: action.payload.pagination
            };

        case LOAD_MESSAGE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            };

        case SAVE_MESSAGE_SUCCESS:
        case DELETE_MESSAGE_SUCCESS:
        case TOGGLE_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false
            };

        case LOAD_ACTIVE_MESSAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                activeMessages: action.payload
            };

        case LOAD_MESSAGES_FAILED:
        case LOAD_MESSAGE_BY_ID_FAILED:
        case SAVE_MESSAGE_FAILED:
        case DELETE_MESSAGE_FAILED:
        case TOGGLE_MESSAGE_FAILED:
        case LOAD_ACTIVE_MESSAGES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default ApplicationMessagesReducer;
